<template>
  <div class="checklist">
    <!-- Nav Bar de Checklist de Engenharia -->
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a @click.prevent="click_checklist" :class="Check">Check list</a>
        <a @click.prevent="click_itemNOK" :class="Check_2">Itens Não/NOK</a>
      </div>
    </nav>

    <!--  Check List -->
    <div v-if="Show_Check == true">
      <!-- Inicializando Tabela -->
      <table-lite
        :is-slot-mode="true"
        :is-loading="isLoading"
        :columns="columns"
        :rows="rows"
        :total="totalRecordCount"
        :sortable="sortable"
        @do-search="doSearch"
        @is-finished="isLoading = false"
      >
        <!-- Colunas -->
        <!-- Descrição -->
        <template v-slot:description="data">
          {{ this.DataChecklist[data.value.number].description }}
        </template>

        <!-- Opção -->
        <template v-slot:opcao="data">
          <select
            v-model="DataChecklist[data.value.number].opcao"
            :disabled="configInputs"
            :class="[
              'input-tamanho',
              {
                error: ValidationAndCondition(
                  DataChecklist[data.value.number].opcao,
                  DataChecklist[data.value.number].opcao
                ),
              },
            ]"
          >
            <option value="1">Sim</option>
            <option value="2">N/A</option>
            <option value="3">N/Ok</option>
            <option value="4">Não</option>
            <option value="5">Ok</option>
          </select>
        </template>

        <!-- Observação -->
        <template v-slot:observacao="data">
          <textarea
            :disabled="configInputs"
            class="input-tamanho"
            v-model="DataChecklist[data.value.number].observacao"
          ></textarea>
        </template>
      </table-lite>
      <!-- Ocultar após testes -->
      <!-- {{DataChecklist}} -->
    </div>

    <!-- Lista de Itens Não/OK -->
    <div v-else>
      <!-- Inicializando Tabela -->
      <table-lite
        :is-slot-mode="true"
        :is-loading="isLoadingNok"
        :columns="columns"
        :rows="rowsNowOk"
        :total="totalRecordCountNok"
        :sortable="sortable"
        @do-search="doSearch_NaoOK"
        @is-finished="isLoadingNok = false"
      >
        <!-- Colunas -->
        <!-- Description -->
        <template v-slot:description="data">
          {{ this.DataItemsNok[data.value.number].description }}
        </template>

        <!-- Opção -->
        <template v-slot:opcao="data">
          {{ DataItemsNok[data.value.number].opcao }}
        </template>

        <!-- Observação -->
        <template v-slot:observacao="data">
          {{ DataItemsNok[data.value.number].observacao }}
        </template>

        <!-- Data -->
        <!-- <template v-slot:data="data">
          {{ DataItemsNok[data.value.number].data }}
        </template> -->

        <!-- Status -->
        <!-- <template v-slot:status="data">
          {{ DataItemsNok[data.value.number].status }}
        </template> -->
      </table-lite>

      <!-- Ocultar após testes -->
      <!-- {{DataItemsNok}} -->
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import TableLite from "./Table-Simple.vue";
import { GetFindAllDataItem } from "../../controllers/ItemsChecklist/GetFindAllDataItem";
import dayjs from "dayjs";

// Orden de dados em forma Crescente
const sampleData1 = (offst, limit) => {
  offst = offst + 1;

  let data = [];
  for (let i = offst; i <= limit; i++) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

//Orden de dados em forma Decrescente
const sampleData2 = (offst, limit) => {
  let data = [];
  for (let i = limit; i > offst; i--) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

export default {
  name: "App",
  components: { TableLite },

  props: {
    configInputs: Number,
  },
  async created() {
    const res = await GetFindAllDataItem();
    if (res != undefined) {
      this.items = res.data.list;
    }

    this.doSearch(0, 10, "description", "asc");

    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
      this.$emit("setDataChecklist", this.DataChecklist);
    }
    // Inicalização Checklist em 0 a 10 dos Items do Banco

    // Criando Objeto Checklist para manipulalo.
    if (this.configInputs == 0) {
      this.items.map((element, index) => {
        this.createChecklist(element.ID, element.DESC);
      });
    }
  },
  data() {
    return {
      Check: "nav-item nav-link font-weight-bold maozinha active",
      Check_2: "nav-item nav-link font-weight-bold maozinha red",
      Show_Check: true,
      DataChecklist: [],
      v$: useVuelidate(),
      DataItemsNok: [],

      // Items que devem vir do banco de dados
      items: [],

      isLoading: false,
      isLoadingNok: false,

      columns: [
        {
          label: "Descrição",
          field: "description",
          width: "10%",
          sortable: true,
        },
        {
          label: "Opção",
          field: "opcao",
          width: "5%",
          sortable: true,
        },
        {
          label: "Observação",
          field: "observacao",
          width: "18%",
          sortable: true,
        },
        // {
        //   label: "Data",
        //   field: "data",
        //   width: "8%",
        //   sortable: true,
        // },

        // {
        //   label: "Status",
        //   field: "status",
        //   width: "5%",
        //   sortable: true,
        // },
      ],

      rows: [],
      rowsNowOk: [],

      totalRecordCount: 0,
      totalRecordCountNok: 0,

      sortable: {
        order: "id",
        sort: "asc",
      },
    };
  },

  computed: {
    ValidationAndCondition() {
      return (option, data) => {
        if (option === "1" && data == "") {
          return true;
        }

        return false;
      };
    },
    ValidationItemSim() {
      return (option, data, status) => {
        if (option === "1" && (data == "" || status == "")) {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "info",
            text: "Preenchimento Obrigatario de Data e Status!",
          });

          return true;
        }
      };
    },
  },

  methods: {
    // Montagem de filro e limite do checklist
    doSearch(offset, limit, order, sort) {
      this.isLoading = true;
      setTimeout(() => {
        const limitePre = this.DataChecklist.length;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rows = sampleData1(offset, limit);
        } else {
          this.rows = sampleData2(offset, limit);
        }

        this.totalRecordCount = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    // Montagem de filro e limite de Itens Não/Ok
    doSearch_NaoOK(offset, limit, order, sort) {
      // this.isLoadingNok = true;
      setTimeout(() => {
        const limitePre = this.DataItemsNok.length;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rowsNowOk = sampleData1(offset, limit);
        } else {
          this.rowsNowOk = sampleData2(offset, limit);
        }

        this.totalRecordCountNok = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    //Criando o Checklist
    createChecklist(id, description) {
      const obj = {
        id: id,
        description: description,
        opcao: "",
        data: "",
        observacao: "",
        status: true,
      };

      this.DataChecklist.push(obj);
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      dataQuery.MoldeFechado[0].checklist.map((element) => {
        let description = this.items.find((data) => data.ID == element.ID_LIST);

        this.DataChecklist.push({
          id: element.ID,
          description: description.DESC,
          opcao: element.OPCAO,
          data: this.ReformDate(element.DATA),
          observacao: element.OBSERVACAO,
          status: element.STATUS,
        });
      });
    },
    //  Enviando dados Não Ok do Checklist para a tabela de Itens Não/Ok
    updateItemsNaoOk() {
      const data = this.DataChecklist;
      const dataNOK = [];
      data.map((element) => {
        // Condicional para lista itens Não / Ok
        if (element.opcao == "3") {
          dataNOK.push(element);
        }
      });
      this.DataItemsNok = dataNOK;
    },

    // Interação com usuarios
    click_checklist() {
      this.Show_Check = true;
      this.Check = "nav-item nav-link font-weight-bold maozinha active";
      this.Check_2 = "nav-item nav-link font-weight-bold maozinha red  ";
    },
    click_itemNOK() {
      this.doSearch_NaoOK(0, 10, "description", "asc"); // Obs : Reajuste de limite e filtro da quantidade atualizada de Itens Não/Ok
      this.Show_Check = false;
      this.Check = "nav-item nav-link font-weight-bold maozinha ";
      this.Check_2 = "nav-item nav-link font-weight-bold maozinha active red";
    },
    ReformDate(date) {
      if (date === null) {
        return null;
      }
      const dataFormatada = dayjs(date).add(1, "days").format("YYYY-MM-DD");
      return dataFormatada;
    },
  },

  watch: {
    //  Monitoração de Obj Checklist
    DataChecklist: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        
        this.updateItemsNaoOk();
        this.$emit("setDataChecklist", newValue);
        this.$store.commit("MutationSetDataChecklistUpdate", newValue);
      },
    },
  },
};
</script>
<style >
input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}

.checklist nav .nav {
  display: flex;
  flex-wrap: initial;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.input-tamanho {
  width: 100%;
  height: 2.5rem !important;
  border: 1px solid var(--cinza) !important;
  border-radius: 0.5rem;
  padding: 0.5rem !important;
  resize: none;
  outline: none;
}

.maozinha {
  cursor: pointer;
}

.red {
  color: var(--red) !important;
}

.error {
  background: var(--redTransparent);
}
</style>
